// extracted by mini-css-extract-plugin
export default {"Breadcrumb-list":"Breadcrumb-list3wDDSRTNEBCQ","Breadcrumb-item":"Breadcrumb-itemhU0JQW_9l3fK","Breadcrumb-separator":"Breadcrumb-separator1MLziD-gOLe-"};